import { Container } from 'react-bootstrap';
import './assets/css/style.scss';
import { useEffect, useMemo, useState } from 'react';
import { MainSectors as MainSec } from '../../../../shared/interfaces';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

function MainSectors() {
  const [sectors, setSectors] = useState<MainSec[]>([]);

  useEffect(() => {
    fetch(
        `https://strapi-production-a706.up.railway.app/api/main-sectors?populate=image&sort=sequence:ASC`
    )
        .then((res) => res.json())
        .then((data) => setSectors(data.data))
        .catch((err) => console.error('Failed to fetch main sectors:', err));
  }, []);

  const normalSectors = useMemo(
      () => sectors.filter((s) => !s?.explore_banner),
      [sectors]
  );

  const bannerSector = useMemo(
      () => sectors.find((s) => s?.explore_banner),
      [sectors]
  );

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1025 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 801 }, items: 2 },
    mobile: { breakpoint: { max: 800, min: 0 }, items: 1 },
  };

  return (
      <div className="section features">
        <Container>
          <div className="section__title">
            <div className="section__label">
              {/* svg unchanged */}
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
                <g clipPath="url(#clip0_18_208)">
                  <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M24.5 0.0145264L16.8419 14.9856H9.64869L12.8538 8.781H12.7098C10.0659 12.213 6.12083 14.4725 0.5 14.9856V8.86682C0.5 8.86682 4.09578 8.65434 6.20975 6.4319H0.5V0.0148545H6.91705V5.2927L7.061 5.29209L9.68328 0.0148545H14.5365V5.25937L14.6804 5.25909L17.4011 0.0145264H24.5Z"
                      fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_18_208">
                    <rect width="24" height="14.971" fill="white" transform="translate(0.5 0.0145264)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2>Sektorët e Akropolit të Ri</h2>
          </div>

          {/* Normal cards: grid on desktop/tablet, carousel handles breakpoints */}
          <div className="features__carousel pagesgrid__carousel">
            <Carousel
                responsive={responsive}
                arrows={false}
                infinite={true}
                draggable={true}
                swipeable={true}
                showDots={true}
                renderDotsOutside={false}
                containerClass="pagesgrid__carousel"
                itemClass="pagesgrid__carousel-item"
            >
              {normalSectors.map((sector, index) => (
                  <div className="features__item" key={sector?.id ?? index}>
                    <div className="features__item-icon">
                      <img src={sector?.image?.url} alt={sector?.title ?? 'sector'} />
                    </div>
                    <div className="features__item-title">
                      <h3>
                        <span>{sector?.title}</span>
                      </h3>
                      <p>{sector?.description}</p>
                    </div>
                  </div>
              ))}
            </Carousel>
          </div>

          {/* Banner card always below */}
          {bannerSector ? (
              <div className="features__banner">
                <div className="features__item features__item_full">
                  <div className="features__item_full-content">
                    {/* svg unchanged */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="15" viewBox="0 0 25 15" fill="none">
                      <g clipPath="url(#clip0_18_208)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M24.5 0.0145264L16.8419 14.9856H9.64869L12.8538 8.781H12.7098C10.0659 12.213 6.12083 14.4725 0.5 14.9856V8.86682C0.5 8.86682 4.09578 8.65434 6.20975 6.4319H0.5V0.0148545H6.91705V5.2927L7.061 5.29209L9.68328 0.0148545H14.5365V5.25937L14.6804 5.25909L17.4011 0.0145264H24.5Z"
                            fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_18_208">
                          <rect width="24" height="14.971" fill="white" transform="translate(0.5 0.0145264)" />
                        </clipPath>
                      </defs>
                    </svg>

                    <h3>
                      <span>{bannerSector?.title}</span>
                    </h3>
                    <p>{bannerSector?.description}</p>

                    <a
                        href="https://www.acropolis.org/en/"
                        target="_blank"
                        className="main-redirect button button--secondary"
                        rel="noreferrer"
                    >
                      <span>Eksploro</span>
                    </a>
                  </div>

                  <div className="features__item-image">
                    <img src={bannerSector?.image?.url} alt={bannerSector?.title ?? 'banner'} />
                  </div>
                </div>
              </div>
          ) : null}
        </Container>
      </div>
  );
}

export default MainSectors;
